class tabContainer extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll('.featured-collection-tab-titles a');
    this.tabPanels = this.querySelectorAll('.tabs__panels > div');
    this.addEventListener('click', this.clickHandler);
    this.addEventListener('keydown', this.KeyDownHandler);
  }

  clickHandler(e){
   const clickedTab = e.target.closest('a');
   if (!clickedTab) return;
   e.preventDefault();
   this.switchTab(clickedTab);
  }

  KeyDownHandler(e) {
    switch (e.key) {
      case 'ArrowLeft':
        this.moveLeft();
        break;
      case 'ArrowRight':
        this.moveRight();
        break;
       case 'ArrowUp':
        e.preventDefault();
        this.moveLeft();
        break;
      case 'ArrowDown':
        e.preventDefault();
        this.moveRight();
        break;
      case 'Home':
        e.preventDefault();
        this.switchTab(this.tabButtons[0]);
        break;
      case 'End':
        e.preventDefault();
        this.switchTab(this.tabButtons[this.tabButtons.length - 1]);
        break;
    }
  }

  moveLeft() {
    const currentTab = document.activeElement;
    if (!currentTab.parentElement.previousElementSibling) {
      this.switchTab(this.tabButtons[this.tabButtons.length - 1]);
    } else {
      this.switchTab(
        currentTab.parentElement.previousElementSibling.querySelector('a')
      );
    }
  }

  moveRight() {
    const currentTab = document.activeElement;
    if (!currentTab.parentElement.nextElementSibling) {
      this.switchTab(this.tabButtons[0]);
    } else {
      this.switchTab(currentTab.parentElement.nextElementSibling.querySelector('a'));
    }
  }

  switchTab(newTab) {
    const activePanelId = newTab.getAttribute('href');
    const activePanel = this.querySelector(activePanelId);
    this.tabButtons.forEach((button) => {
      button.setAttribute('aria-selected', false);
      button.setAttribute('tabindex', '-1');
    });
  
    this.tabPanels.forEach((panel) => {
      panel.setAttribute('hidden', true);
    });
  
    activePanel.removeAttribute('hidden', false);
  
    newTab.setAttribute('aria-selected', true);
    newTab.setAttribute('tabindex', '0');
    newTab.focus();
  }
}

customElements.define('tab-container', tabContainer);
